var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('basic-dialog',{attrs:{"id":"success-dialog","primaryButton":"Close","primaryClick":_vm.close,"isDisabled":false}},[_c('div',[_c('h1',{staticClass:"status-message"},[_vm._v(_vm._s(_vm.message)),_c('i',{staticClass:"fa fa-check-circle fa-lg ml-3",attrs:{"aria-hidden":"true"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }